
import {
    Box, TextField, FormControl, InputAdornment, InputLabel, Input, IconButton, Button,
    Typography, Select, MenuItem, FormHelperText, Alert, Chip
} from '@mui/material';
import { AccountCircleOutlined, Visibility, VisibilityOff, LockOutlined, Group } from '@mui/icons-material';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch, } from 'react-redux';
import { set } from 'lodash';
import { Tabs } from '../../components/tabs';
import { Grid } from '../../components/table';
import { CONFIG } from '../../../config'
import axios from 'axios';
import { ToolBar } from '../../components/toolbar';
import { Modal } from '../../components/modal';
import { FormA } from '../../components/form';
import moment from 'moment';
import {getFormState} from '../../../helpers/form';
import dayjs from 'dayjs';
import { useHistory, useLocation, useParams } from "react-router-dom";

const API_HOST = CONFIG.modules['accounts'].host


export const CampaignList = (props) => {
    const { roles, user, users, Designations, Departments, Languages, Districts, Campaigns, map } = useSelector((state) => (state.user || {}))

    const history = useHistory();
    const [list, setList] = useState([])

    useEffect(()=> {
        if(Campaigns) {
            setList([...Campaigns])
        }
    }, [Campaigns])



    // const handleSubmit = () => {
    //     axios.post(API_HOST , {
    //         user: {...formData} 
    //     }).then((resp) => {
    //         if (resp.data && resp.data.success) {
    //             setOpen(false)
    //             setData([resp.data.data, ...data])
    //         }
    //     }).catch((e) => {
    //         console.log(e)
    //     })
    // }

    // const handleEdit = () => {
    //     if(formData.password == '') {
    //         delete formData.password
    //     }
    //     axios.put(API_HOST + `/${saved._id}`, {
    //         user: formData
    //     }).then((resp) => {
    //         if (resp.data && resp.data.success) {
    //             setOpen(false)
    //             data[index] = resp.data.user
    //             setData([...data])
    //         }
    //     }).catch((e) => {
    //         console.log(e)
    //     })
    // }

    // const handleDelete = () => {
    //     axios.delete(API_HOST + '/'+saved._id).then((resp) => {
    //         if (resp.data && resp.data.success) {
    //             setOpenConfirm(false)
    //             data.splice(index, 1)
    //             setData([...data])
    //         }
    //     }).catch((e) => {
    //         console.log(e)
    //     })
    // }
    return (
        <>
    
            <Box sx={{ mt: 2 }}>
                <Grid data={list} columns={[
                  { id: 'createdAt', label: 'Created At', minWidth: 60, format:(data, row)  => {
                    return data? dayjs(data).format('DD-MM-YYYY hh:mm:ss'):''
                }},
                { id: 'updatedAt', label: 'Updated At', minWidth: 60, format:(data, row)  => {
                    return data? dayjs(data).format('DD-MM-YYYY hh:mm:ss'):''} }
                  
                ]}
                    actions={[
                        {
                            name: 'Edit',
                            onClick: (id) => {
                                // setIndex(id)
                                // setSaved(data[id])
                                // const newData = {...data[id]}
                                // newData.password = ''
                                // newData.dob =  dayjs(newData.dob)
                                // newData.dateOfJoining = dayjs(newData.dateOfJoining)
                                // if(newData.departments) {
                                //     newData.departments = newData.departments.map(d=>d._id)
                                // }
                                // if(newData.designation) {
                                //     newData.designation = newData.designation.map(d=>d._id)
                                // }
                                // setFormData(newData)
                                // setAction('edit')
                                // setOpen(true)
                            
                                
                            }
                        },
                        {
                            name: 'Delete',
                            onClick: (id) => {
                                // setIndex(id)
                                // setSaved(data[id])
                                // setOpenConfirm(true)
                            }
                        }
                    ]}></Grid>
            </Box>
            {/* <Modal open={open}
                handleClose={() => { setOpen(false) }}
                head={`${action == 'new' ? 'Add' : 'Edit'} ${active}`}
                buttons={[
                    {
                        name: 'Cancel',
                        onClick: () => {
                            setOpen(false)
                        }
                    },
                    {
                        name: action == 'new' ? 'Create' : 'Save',
                        onClick: () => {
                            switch (action) {
                                case 'new':
                                    handleSubmit()
                                    break;
                                case 'edit':
                                    setDepartmentsFiltered((Departments||[]).filter(e=>e.type == formData.department_type))
                                    handleEdit()
                                    break;
                                default: break;
                            }
                        }
                    }
                ]}

            >
                 {
                    action == 'edit' &&
                    <Typography variant='p' color="grey">{
                        'ID: ' + saved._id
                    }</Typography>
                }
                {
                    Array.isArray(fields) &&
                    <FormA fields={fields}
                        data={{ roles, Designations, Districts, Languages, Departments, DepartmentsFiltered, users, department_types: [
                            {
                                _id: 'Core',
                                name: 'Core'
                            },
                            {
                                _id: 'Project Based',
                                name: 'Project Based'
                            }
                            
                        ] }}
                        onChange={(name, value, multiple) => {
                            formData[name] = value
                            setFormData({ ...formData })
                        }}
                        state={formData||{}}
                    />
                }
               

            </Modal>

            <Modal open={openConfirm}
                handleClose={() => { setOpen(false) }}
                head={`${'Delete'} ${active}`}
                desc={`Please confirm to delete the following ${active}?`}
                buttons={[
                    {
                        name: 'Cancel',
                        onClick: () => {
                            setOpenConfirm(false)
                        }
                    },
                    {
                        name: 'Delete',
                        onClick: () => {
                            handleDelete()
                        }
                    }
                ]}

            >
                {
                    saved &&
                    <Box>
                        <Typography variant='p' color="grey">{'ID: ' + saved._id}</Typography><br></br>
                        <Typography variant='p' color="grey">{'Name: ' + saved.name}</Typography>
                    </Box>
                }

            </Modal> */}
        </>
    )
}